//猪场类型
export const farmTypeList = [
  {farmTypeId:1,farmTypeName:'母猪场'},
  {farmTypeId:2,farmTypeName:'育肥场'}
]
//猪场性质
export const farmPropertiesList = [
  {farmPropertiesId:1,farmPropertiesName:'散户'},
  {farmPropertiesId:2,farmPropertiesName:'规模场'}
]
//饲养模式
export const feedingPatternList = [
  {feedingPatternId:1,feedingPatternName:'自繁自养'},
  {feedingPatternId:2,feedingPatternName:'商品育肥'}
]
//栏舍类型
export const fenceTypeList = [
  {fenceTypeId:1,fenceTypeName:'封闭式（人工控温）'},
  {fenceTypeId:2,fenceTypeName:'开放式'}
]
//地板类型
export const floorTypeList = [
  {floorTypeId:1,floorTypeName:'漏缝地板'},
  {floorTypeId:2,floorTypeName:'半漏缝地板'},
  {floorTypeId:3,floorTypeName:'发酵床'},
]
//粪水处理
export const fecalWaterList = [
  {fecalWaterId:1,fecalWaterName:'水泡粪'},
  {fecalWaterId:2,fecalWaterName:'干清粪'},
  {fecalWaterId:3,fecalWaterName:'水冲粪'},
]
//免疫情况
export const vaccinationList = [
  {vaccinationValue:1,vaccinationName:'是'},
  {vaccinationValue:0,vaccinationName:'否'},
]
//产品定位
export const productPositionList = [
  {productPositionId:1,productPositionName:'高档'},
  {productPositionId:2,productPositionName:'中档'},
  {productPositionId:3,productPositionName:'低档'},
]
